import React, { PropsWithChildren } from 'react';
import { Popup } from 'semantic-ui-react';

type TableActionTooltipProps<TData> = {
  tooltipContent: string | ((item: TData) => JSX.Element) | undefined;
  position?:
    | 'top left'
    | 'top right'
    | 'bottom right'
    | 'bottom left'
    | 'right center'
    | 'left center'
    | 'top center'
    | 'bottom center';
  item: TData;
};

export const TableActionTooltip = <TData,>(
  props: PropsWithChildren<TableActionTooltipProps<TData>>
) => {
  const content =
    typeof props.tooltipContent === 'string'
      ? props.tooltipContent
      : props.tooltipContent?.(props.item);

  return (
    <Popup
      content={content}
      basic
      size="mini"
      className="p-os-tooltip"
      on="hover"
      position={props.position}
      trigger={props.children}
    />
  );
};
